export default {
  GAME: 'SPILL',
  Top: 'Topp',
  HISTORY: 'HISTORIE',
};
